// extracted by mini-css-extract-plugin
export default {"container":"ExpandingFlexCard_container__EpSLG","gallery":"ExpandingFlexCard_gallery__jQqtR","img-box":"ExpandingFlexCard_img-box__BTa6t"};